import { Component, inject, Input } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { ProgressBar } from 'primeng/progressbar';
import { LayoutService } from '../../../layout/services/layout.service';

@Component({
  selector: 'sps-progress-dialog',
  imports: [
    Dialog,
    ProgressBar
  ],
  templateUrl: './sps-progress-dialog.component.html'
})
export class SpsProgressDialogComponent {

  @Input() title: string;
  @Input() widthValue: string = '30rem';
  @Input() showProgressSpinner: boolean = false;
  public layoutService = inject(LayoutService);

}
